import React from 'react';
import Style from 'style-it';

var BackgroundImage = function BackgroundImage(image, hash) {
  return /*#__PURE__*/React.createElement(Style, null, ".rbiHandler-" + hash + " { background-image: url(" + image + "); } ");
};

export { BackgroundImage };